export interface Article {
  id: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  imageSeq: string;
  imageWidth: number;
  imageHeight: number;
  imageQuery: string;
  author: string;
  date: string;
  isHot: boolean;
  isExclusive: boolean;
  readCount: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '某千万粉丝网红深夜直播翻车，不当言论引发全网抵制',
    summary: '拥有超过1200万粉丝的知名网红在深夜直播中发表不当言论，引发网友强烈不满。随后被扒出更多黑历史，多个品牌方连夜解约。事件持续发酵中，平台已对其直播间进行封禁处理。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageSeq: 'article-001',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Dramatic night scene of a livestream studio with neon lights and smartphone screens glowing in darkness, abstract artistic composition with lime green accents, dark moody atmosphere, modern Chinese entertainment industry aesthetic, high contrast, editorial photography style with soft shadows and cinematic lighting, no realistic faces visible just silhouettes and technology glow',
    author: '吃瓜小编',
    date: '2026-07-06',
    isHot: true,
    isExclusive: true,
    readCount: 289000,
    tags: ['直播翻车', '网红塌房', '品牌解约', '全网抵制'],
  },
  {
    id: 'article-002',
    title: '顶流男星恋情疑似曝光！与神秘女子同游三亚被拍',
    summary: '近日有网友在三亚偶遇某顶流男星与一名神秘女子亲密同行，照片在社交平台疯传。粉丝群体瞬间炸锅，评论区两极分化严重。男方工作室暂未回应，女方身份成谜。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageSeq: 'article-002',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Blurry paparazzi style photograph of tropical beach scene at sunset, palm trees and ocean waves, warm golden light, mysterious romantic atmosphere, artistic grain texture, editorial celebrity gossip photography, abstract figures in distance, soft focus dreamy quality, warm neutral tones',
    author: '瓜田守望者',
    date: '2026-07-05',
    isHot: true,
    isExclusive: false,
    readCount: 456000,
    tags: ['顶流男星', '恋情曝光', '三亚', '明星八卦'],
  },
  {
    id: 'article-003',
    title: '某带货主播产品质量翻车，消费者集体维权索赔千万',
    summary: '知名带货主播推荐的多款产品被消费者投诉质量严重不合格，涉及护肤品、食品等多个品类。目前已有超过5000名消费者加入维权群，索赔金额累计突破千万元。相关部门已介入调查。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageSeq: 'article-003',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Dramatic still life composition of broken cosmetics and packaging scattered on dark surface, harsh spotlight creating dramatic shadows, lime green warning tape accents, editorial product photography with critical consumer journalism aesthetic, dark moody atmosphere, high detail product closeups, clean white background contrasting with damaged items',
    author: '吃瓜小编',
    date: '2026-07-06',
    isHot: true,
    isExclusive: true,
    readCount: 312000,
    tags: ['带货翻车', '产品质量', '消费者维权', '索赔'],
  },
  {
    id: 'article-004',
    title: '娱乐圈知名夫妻被曝已分居半年，各自精彩生活引猜测',
    summary: '圈内人爆料某对曾经被誉为模范夫妻的明星夫妇实际上已经分居长达半年之久，两人各自在社交平台上的动态也被网友细心扒出端倪。这段婚姻是否走到了尽头？',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageSeq: 'article-004',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Split composition showing two separate elegant modern apartments with different color schemes, subtle storytelling through interior design details, warm and cool lighting contrast, cinematic framing, artistic editorial photography, sophisticated mood, neutral warm tones with subtle separation theme',
    author: '深度扒皮',
    date: '2026-07-04',
    isHot: false,
    isExclusive: true,
    readCount: 198000,
    tags: ['明星夫妻', '分居', '婚姻危机', '娱乐圈'],
  },
  {
    id: 'article-005',
    title: '某选秀节目选手被曝学历造假，节目组紧急声明',
    summary: '热门选秀节目人气选手被网友扒出学历信息造假，其声称的海外名校留学经历查无实据。节目组随后发布紧急声明表示正在核实情况，该选手已暂停所有宣传活动。',
    category: '独家爆料',
    categorySlug: 'dujia-baoliao',
    imageSeq: 'article-005',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Abstract composition of graduation certificates and stage spotlights overlapping in dark space, dramatic contrast between academic symbols and entertainment glamour, lime green accent lighting creating tension, modern Chinese variety show aesthetic, editorial photography style, mysterious and investigative atmosphere',
    author: '独家线人',
    date: '2026-07-03',
    isHot: false,
    isExclusive: true,
    readCount: 267000,
    tags: ['选秀节目', '学历造假', '节目组声明', '选手争议'],
  },
  {
    id: 'article-006',
    title: '热门综艺录制现场突发意外，多位嘉宾受伤送医',
    summary: '某热门综艺节目在户外录制过程中突发意外事故，导致包括常驻嘉宾和飞行嘉宾在内的多人受伤。目前伤者已被紧急送往附近医院救治，节目组已暂停全部录制工作并启动安全排查。',
    category: '热门事件',
    categorySlug: 'remen-shijian',
    imageSeq: 'article-006',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Dramatic outdoor film set scene with equipment and lighting rigs against moody sky, subtle emergency vehicle lights in distance, cinematic composition, news journalism photography style, tense atmosphere, warm neutral tones with urgency conveyed through lighting, no visible injuries or people, focused on environment storytelling',
    author: '实时追踪',
    date: '2026-07-06',
    isHot: true,
    isExclusive: false,
    readCount: 523000,
    tags: ['综艺事故', '嘉宾受伤', '录制现场', '紧急送医'],
  },
  {
    id: 'article-007',
    title: '短视频平台两大头部网红互撕，背后金主浮出水面',
    summary: '两大短视频平台头部网红近日在社交平台上隔空互撕，互相爆料对方的不为人知的秘密。随着事件的深入，多位业内人士爆料称双方背后涉及同一资本力量，互撕或为精心策划的流量炒作。',
    category: '独家爆料',
    categorySlug: 'dujia-baoliao',
    imageSeq: 'article-007',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Abstract split screen composition showing two contrasting smartphone screens with social media interfaces glowing in dark space, dramatic lime green and warm amber light split, digital conflict aesthetic, modern internet culture photography, high contrast editorial style, clean dark background with neon accent lighting',
    author: '独家线人',
    date: '2026-07-05',
    isHot: true,
    isExclusive: true,
    readCount: 389000,
    tags: ['网红互撕', '资本操控', '流量炒作', '短视频'],
  },
  {
    id: 'article-008',
    title: '某知名导演新片选角内幕曝光，潜规则丑闻震惊业内',
    summary: '一位不愿透露姓名的演员向吃瓜51独家爆料某知名导演在新片选角过程中存在严重潜规则行为。该导演曾执导多部票房过亿作品，此事一旦坐实将对整个行业造成巨大冲击。',
    category: '独家爆料',
    categorySlug: 'dujia-baoliao',
    imageSeq: 'article-008',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Dark cinema auditorium with single spotlight on empty director chair, dramatic shadow play, mysterious and tense atmosphere, film industry aesthetic, editorial investigative journalism photography, lime green accent rim light creating intrigue, cinematic composition, high contrast noir style',
    author: '吃瓜小编',
    date: '2026-07-02',
    isHot: false,
    isExclusive: true,
    readCount: 445000,
    tags: ['导演丑闻', '选角内幕', '潜规则', '电影行业'],
  },
  {
    id: 'article-009',
    title: '某女星离婚后首度公开亮相，状态惊艳全场',
    summary: '在经历了一场轰轰烈烈的离婚风波后，某知名女星昨日在某品牌活动中首度公开亮相。其精神状态和外形条件均保持极佳水准，引发全场媒体聚焦。采访中她坦然面对过去，表示已开启新的人生篇章。',
    category: '实时追踪',
    categorySlug: 'shishi-zhuizong',
    imageSeq: 'article-009',
    imageWidth: 800,
    imageHeight: 600,
    imageQuery: 'Elegant red carpet event scene with dramatic spotlight and camera flashes, glamorous atmosphere, fashion photography aesthetic, warm gold and champagne tones, sophisticated luxury event styling, editorial celebrity photography, soft glowing light, clean elegant background with artistic blur',
    author: '实时追踪',
    date: '2026-07-07',
    isHot: false,
    isExclusive: false,
    readCount: 176000,
    tags: ['女星离婚', '公开亮相', '状态惊艳', '品牌活动'],
  },
];

export const categories = [
  { name: '网红塌房', slug: 'wanghong-tafang', icon: 'ri-alert-line', description: '网红圈塌房事件第一时间追踪报道' },
  { name: '明星八卦', slug: 'mingxing-bagua', icon: 'ri-star-line', description: '娱乐圈明星最新动态与八卦消息' },
  { name: '热门事件', slug: 'remen-shijian', icon: 'ri-fire-line', description: '全网最热门的吃瓜事件实时追踪' },
  { name: '独家爆料', slug: 'dujia-baoliao', icon: 'ri-spy-line', description: '吃瓜51独家内幕爆料，别处看不到' },
  { name: '实时追踪', slug: 'shishi-zhuizong', icon: 'ri-radar-line', description: '热点事件持续跟进，不错过任何细节' },
];

export const testimonials = [
  {
    name: '资深吃瓜群众',
    avatarSeq: 'avatar-01',
    comment: '每天打开手机第一件事就是刷吃瓜51，比微博还快！爆料内容真实可靠，不是那种标题党，真的是良心瓜田。',
    rating: 5,
    role: '忠实用户 · 3年',
  },
  {
    name: '娱乐圈边缘人',
    avatarSeq: 'avatar-02',
    comment: '业内人都知道吃瓜51的消息源有多硬。很多所谓的独家新闻其实都是从这里最先爆出来的，其他地方都是跟风转发。',
    rating: 5,
    role: '业内人士 · 2年',
  },
  {
    name: '吃瓜不嫌事大',
    avatarSeq: 'avatar-03',
    comment: '自从关注了吃瓜51，我成了朋友圈里的消息灵通人士。每次聚会都是我给大家分享最新瓜料，朋友们都说我是情报局长。',
    rating: 4,
    role: '活跃用户 · 1年',
  },
];